<template>
  <div style="margin:20px">
    <FiPageRail title="Driver Bid Board">
      <template #actions>
        <span style="float:right;">
          <b-button variant="info" size="sm" @click="showColorInfo = !showColorInfo"><b>info</b></b-button>
        </span>
      </template>
    </FiPageRail>
      <div class="container mt-3" style="max-width:420px;">
      <div class="card shadow-sm">
        <!-- Header -->
        <div class="card-header py-2 px-3 d-flex justify-content-between align-items-center"
          @click="expanded = !expanded" style="cursor:pointer">
          <div>
            <div class="font-weight-bold small">
              {{ monthYear }}
            </div>
            <div style="font-size:12px;">
              <span class="text-success mr-2">Available: {{ yesCount }}</span>
              <span class="text-danger">Not Available: {{ noCount }}</span>
            </div>
          </div>
          <small>{{ expanded ? "▲" : "▼" }}</small>
        </div>

        <div v-show="expanded" class="card-body p-2">

          <!-- Navigation -->
          <div class="d-flex justify-content-between mb-2">
            <button class="btn btn-sm btn-light" :disabled="!canGoPrev" @click="prevMonth">
              ‹
            </button>

            <button class="btn btn-sm btn-light" :disabled="!canGoNext" @click="nextMonth">
              ›
            </button>
          </div>

          <!-- Weekdays -->
          <div class="row text-center small font-weight-bold">
            <div class="col p-1 border" v-for="day in weekdays" :key="day">
              {{ day.charAt(0) }}
            </div>
          </div>

          <!-- Month Grid -->
          <div class="row text-center" v-for="(week, wIndex) in monthGrid" :key="wIndex">
            <div class="col border p-1 d-flex align-items-center justify-content-center" v-for="(day, dIndex) in week"
              :key="dIndex" :class="dayClass(day)" style="height:38px; font-size:13px; cursor:pointer;"
              @click="handleClick(day)">
              {{ day.date.getDate() }}
            </div>
          </div>

          <!-- Save -->
          <div class="text-right mt-2">
            <button class="btn btn-success btn-sm py-0 px-2" @click="saveRanges">
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="bid-controls d-flex flex-wrap align-items-center justify-content-center" style="font-size: 22px; font-weight: bold; margin-top: 20px; position: relative; gap: 6px;">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Get Results</b-button>
      <span v-if="(base_options && base_options.length > 2) && !is_driver_role()">
        &nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      </span>
    </div>
    <div v-if="bid_due_warning" class="bid-due-banner" style="margin-top: 15px; font-size: 20px; font-weight: bold;">
        {{ bid_due_warning }} by 11am EST on {{ bid_due_Date }}
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="padding:5px; border: 1px solid grey;">{{items.length}} results</div>
        <div class="col" style="padding:5px"><b-button v-on:click.prevent="load_data()">Reload</b-button></div>
        <!-- <div style="margin: 5px"><b-button size="md" variant="success" @click="download">Download</b-button></div>
        <div style="margin: 5px" @click="printPage()"><img height="30px" src="/print-icon.png"/></div> -->
      </div>
    </div>

    <b-modal v-model="showColorInfo" title="Row Colors & Bid Awards" size="lg" hide-footer>
      <div class="mb-3">
        <h6>Row colors</h6>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#ffffff; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Normal row (no bid, not cancelled)</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#f2f2f2; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Alternate row shading</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#e6ffed; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Has a bid for this trip</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#ffecec; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Booking is cancelled</span>
        </div>
        <div style="display:flex; align-items:center; margin-bottom:6px;">
          <div style="width:20px; height:16px; background:#9ac2ff; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Bid award is WON or REQ</span>
        </div>
        <div style="display:flex; align-items:center;">
          <div style="width:20px; height:16px; background:#c9a227; border:1px solid #ccc; margin-right:8px;"></div>
          <span>Bid has another award status (not WON/REQ)</span>
        </div>
      </div>

      <div>
        <h6>Bid Awarded Options</h6>
        <ul style="padding-left:18px; margin-bottom:0;">
          <li><strong>WON</strong> – Bid was awarded</li>
          <li><strong>OBD</strong> – Outbid by a Driver with more Seniority</li>
          <li><strong>OBR</strong> – Outbid by a Driver Request</li>
          <li><strong>HOS</strong> – Bid was considered but HOS concerns prevented award</li>
          <li><strong>NEB</strong> – Not Eligible to bid</li>
          <li><strong>REQ</strong> – Awarded due to customer request</li>
        </ul>
      </div>
    </b-modal>

    <!-- <vue-html2pdf
        :enable-download="true"
        :manual-pagination="true"
        :filename="'daily-dispatch-board-' + details_fromDate"
        pdf-format="letter"
        margin="0px"
        pdf-orientation="landscape"
        pdf-content-width="1050px"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <html>
          <template v-for="page in Array(Math.ceil(items.length / 25)).keys()">
          <br/>
            <table border="1" v-if="summary">
              <tr style="font-size: 10px">
                <th>Booking</th>
                <th>Organization</th>
                <th>Requested Driver</th>
                
                <th>Trip Ref</th>
                <th>Pickup Location</th>
                <th>Destination</th>
                <th>Driver</th>
                <th>Price</th>
                <th>Miles</th>
                <th>Veh Type</th>
                <th width="70px">Driver Start</th>
                <th width="70px">Base of Operation</th>
                <th width="70px">Departure</th>
                <th width="70px">Arrival</th>
                <th width="70px">Driver End</th>
              </tr>
              <template v-if="idx >= (page * 25) && idx < ((page+1)*25)" v-for="(item,idx) in items">
                <tr>
                  <td style="font-size: 12px">{{item.booking_id}}</td>
                  <td style="font-size: 10px">{{item.organization | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.requested_driver | trim(28)}}</td>
                  
                  <td style="font-size: 10px;">{{item.trip_reference | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.first_pickup_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.destination_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.driver}}</td>
                  <td style="font-size: 12px">{{item.price}}</td>
                  <td style="font-size: 12px">{{item.miles}}</td>
                  <td style="font-size: 10px">{{item.vehicle_type}}</td>
                  <td style="font-size: 12px">{{item.driver_start}}</td>
                  <td style="font-size: 12px">{{item.base_of_operation}}</td>
                  <td style="font-size: 12px">{{item.departure_time}}</td>
                  <td style="font-size: 12px">{{item.arrival_time}}</td>
                  <td style="font-size: 12px">{{item.driver_end}}</td>
                </tr>
              </template>
            </table>
            <br/>
            <table width="1000px">
              <tr>
                <td>Page {{page+1}} of {{Math.ceil(items.length/25)}}</td>
                <td align="right">{{current_date}}</td>
              </tr>
            </table>

            <div v-if="page+1 != Math.ceil(items.length/25)" class="html2pdf__page-break"/>

          </template>
        </html>
      </section>
    </vue-html2pdf> -->

    <div v-if="summary && !loading">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        
        <!-- <template slot="status_msg" slot-scope="row">
          <div style="text-align: left" v-for="msg in row.item.status_msg.split(',')">
            <span v-html="msg"/>
          </div>
        </template> -->

        <template slot="booking_id" slot-scope="row">
          {{row.item.booking_id | trim(50)}}
        </template>
        <template slot="organization" slot-scope="row">
          {{row.item.organization | trim(30)}}
        </template>
        <template slot="requested_driver" slot-scope="row">
          {{row.item.requested_driver | trim(50)}}
        </template>
        <template slot="first_pickup_location" slot-scope="row">
          {{findCityState(row.item.first_pickup_location)}}
        </template>
        <template slot="destination_location" slot-scope="row">
          <span class="d-none d-md-inline">{{findCityState(row.item.destination_location)}}</span>
          <span class="d-md-none destination-stacked">
            <span>{{ getCityOnly(row.item.destination_location) }}</span>
            <span>{{ getStateOnly(row.item.destination_location) }}</span>
          </span>
        </template>
         <template slot="driver_start" slot-scope="row">
          {{row.item.driver_start | trim(50)}}
        </template>
         <template slot="driver" slot-scope="row">
          {{row.item.driver | trim(40)}}
        </template>
         <template slot="price" slot-scope="row">
          {{row.item.price | trim(30)}}
        </template>
         <template slot="miles" slot-scope="row">
          {{row.item.miles | trim(30)}}
        </template>
         <template slot="vehicle_type" slot-scope="row">
          {{row.item.vehicle_type | trim(30)}}
        </template>

         <!-- <template slot="trip_reference" slot-scope="row">
          {{row.item.trip_reference | trim(50)}}
        </template> -->

        <template slot="details" slot-scope="row">
          <div style="align-content: center">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? '-' : '+' }}
            </b-button>&nbsp;
          </div>
        </template>

        <template slot="row-details" slot-scope="row">

          <div class="row-detail-wrap" style="text-align: left; padding: 10px; margin:10px; border: 1px dotted grey">
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px; margin-bottom: 8px;">
              <div style="white-space: nowrap;">
                Bid Order
                <select
                  v-model="row.item.bid_order"
                  @change="onChange(row)"
                  style="min-width: 140px; margin-left: 8px; display: inline-block;"
                  :disabled="row.item.booking_status && row.item.booking_status !== 'open'"
                >
                  <option value="">Select Bid Order</option>
                  <option value="1" :disabled="isBidOrderDisabled(row.item, '1')">1</option>
                  <option value="2" :disabled="isBidOrderDisabled(row.item, '2')">2</option>
                  <option value="3" :disabled="isBidOrderDisabled(row.item, '3')">3</option>
                  <option value="4" :disabled="isBidOrderDisabled(row.item, '4')">4</option>
                  <option value="5" :disabled="isBidOrderDisabled(row.item, '5')">5</option>
                  <option value="6" :disabled="isBidOrderDisabled(row.item, '6')">6</option>
                  <option value="7" :disabled="isBidOrderDisabled(row.item, '7')">7</option>
                  <option value="8" :disabled="isBidOrderDisabled(row.item, '8')">8</option>
                  <option value="9" :disabled="isBidOrderDisabled(row.item, '9')">9</option>
                  <option value="10" :disabled="isBidOrderDisabled(row.item, '10')">10</option>
                </select>
              </div>
              <div style="white-space: nowrap;">
                <span style="font-weight: bold;">Driver Request Acknowledged</span>
                <input
                  type="checkbox"
                  v-model="row.item.driver_ack"
                  style="margin-left: 8px; vertical-align: middle;"
                  :disabled="isBidDisabled(row.item)"
                />
              </div>
              <div style="white-space: nowrap;">
                <button
                  @click="submit(row)"
                  style="margin-right: 8px;"
                  :disabled="isBidDisabled(row.item)"
                >
                  Submit
                </button>
                <button
                  @click="remove_bid(row)"
                  :disabled="isBidDisabled(row.item)"
                >
                  Delete
                </button>
                <span v-if="row.item.approval" style="margin-left: 8px;">
                  {{ getApprovalText(row.item.approval) }}
                </span>
              </div>
              <div>
                <b-alert v-model="bidAlert.show" :variant="bidAlert.variant" dismissible fade id="root-alert">
                    {{bidAlert.message}}
                </b-alert>
              </div>
            </div>
            <table class="detail-info-table" width="100%">
              <tr>
                <td style="text-align: left;">Driver Start</td>
                <td>{{row.item.driver_start }}</td>
                <td style="text-align: left;">Driver End</td>
                <td>{{row.item.driver_end }}</td>
              </tr><tr>
                <td style="text-align: left;">Trip Reference</td>
                <td>{{row.item.trip_reference }}</td>
                <td style="text-align: left;">Booking ID</td>
                <td>{{row.item.booking_id }}</td>
              </tr><tr>
                <td style="text-align: left;">Organization</td>
                <td>{{row.item.organization }}</td>
                <td style="text-align: left;">Base of Operation</td>
                <td>{{row.item.base_of_operation }}</td>
              </tr><tr>
                <td style="text-align: left;">Pickup Location</td>
                <td>{{ row.item.first_pickup_location }}</td>
                <td style="text-align: left;">Destination Location</td>
                <td>{{row.item.destination_location }}</td>
              </tr>
            </table>
          </div>
        </template>


      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="loading">
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {get_booking_bids_for_drivers_board, get_booking_bids_for_drivers_board_base, add_update_driver_bid, remove_bid_record, add_update_driver_unavailable, get_drivers_unavailable_ranges, tbn_api_url} from "../networking/tbn_apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'driver_bid_board_tbn',
  components: {
     datetime, VueHtml2pdf
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    const today = new Date()
    const maxDate = new Date()
    maxDate.setMonth(maxDate.getMonth() + 6)
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(moment()),
      details_toDate: justDate(moment()),
      range_fromDate: justDate(moment()),
      range_toDate: justDate(moment()),
      bid_due_Date: justDate(moment()),
      bid_due_warning: '',
      showColorInfo: false,
      items: [],
      items_full: [],
      summary: null,
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      base_options: [],
      driver_options: [],
      selected_base: '',
      company_location: '',
      expanded: false,
      currentMonth: moment().month(),
      currentYear: moment().year(),
      rangeStart: null,
      ranges: [], // STORED RANGES
      weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      maxDate: maxDate,
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      bidAlert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      rows: [
        { id: 1, name: 'Alice', status: 'Active' },
        { id: 2, name: 'Bob', status: 'Inactive' }
      ],
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: '9px', maxWidth: '11px' }},
        { key: 'booking_id', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'dispatch_id', sortable: true, visible: true, thStyle: { width: "60px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        { key: 'organization', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'requested_driver', sortable: true, visible: true, thStyle: { width: "100px" }},
        // { key: 'group_name', sortable: true, visible: true, thStyle: { width: "150px" }},
        //{ key: 'trip_reference', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'first_pickup_location', sortable: true, visible: true, thStyle: { width: "200px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        { key: 'destination_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'driver_start', sortable: true, visible: true, thStyle: { width: "100px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        { key: 'driver', sortable: true, visible: true, thStyle: { width: "100px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        { key: 'price', sortable: true, visible: true, thStyle: { width: "60px" }},
        { key: 'miles', sortable: true, visible: true, thStyle: { width: "60px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        { key: 'vehicle_type', sortable: true, visible: true, thStyle: { width: "80px" }, thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell' },
        //{ key: 'base_of_operation', sortable: true, visible: true, thStyle: { width: "200px" }},
        //{ key: 'departure_time', label: 'First Departure', sortable: true, visible: true},
        //{ key: 'arrival_time', label: 'Last Arrival', sortable: true, visible: true},
        //{ key: 'driver_end', sortable: true, visible: true, thStyle: { width: "200px" }}
      ],
      approvalOptions: [
        { value: '', text: '' },
        { value: 'WON', text: 'Bid was awarded' },
        { value: 'OBD', text: 'Outbid by a Driver with more Seniority' },
        { value: 'OBR', text: 'Outbid by a Driver Request' },
        { value: 'HOS', text: 'Bid was considered but HOS concerns prevented award' },
        { value: 'NEB', text: 'Not Eligible to bid' },
        { value: 'REQ', text: 'Awarded due to customer request' },
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    this.setup_to_from_bid_dates()
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    printPage() {
      this.$refs.html2Pdf.generatePdf()
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    showBidAlert(msg, variant, autoclose) {
      this.bidAlert.show = true
      this.bidAlert.message = msg
      this.bidAlert.variant = variant
      autoclose
          ? setTimeout(() => this.closeBidAlert(), autoclose)
          : null
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeBidAlert() {
      this.bidAlert.show = false
      this.bidAlert.message = ''
      this.bidAlert.variant = ''
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {
      this.fields = this.fields_all
      //this.load_data()
      this.driver_options = []
      this.company_location = this.user.company_location
      // try {
      //   const {value: {data = []}} = await get_driver_list(this.user.tenant)
      //   this.driver_options = data
      // } catch(e) {
      //   this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      // }
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
      const isCancelled = item.cancelled
      if (isCancelled) {
        return 'rowred'
      }
      const hasApprovalWonOrReq = ((String(item.approval || '').toUpperCase() === 'WON' || String(item.approval || '').toUpperCase() === 'REQ')
      )
      const approvalUpper = (v) => String(v || '').toUpperCase()
      const isWonOrReq = (a) => a === 'WON' || a === 'REQ'
      // const hasApprovalWonOrReq = isWonOrReq(approvalUpper(item.approval)) ||
      //   (item.bids || []).some((b) => b && isWonOrReq(approvalUpper(b.approval)))
      const hasOtherApproval = (item.approval && !isWonOrReq(approvalUpper(item.approval))) 
      const hasBidOrder = item.bid_order !== undefined && item.bid_order !== null && String(item.bid_order).trim() !== ''

      if (hasApprovalWonOrReq) return 'rowblue'
      if (hasOtherApproval) return 'rowyellow'
      if (hasBidOrder) {
        return 'rowgreen'
      }
      if (item.row_id % 2 === 0) {
        return 'rowgray'
      }
      return 'rowgray-dark'
    },
    is_driver_role() {
      return this.user.role == 'driver'
    },
    async load_data() {
      this.loading = true
      try {
        var results = null
        //console.log('role: ' + this.user.role + ", location: " + this.company_location)
        //console.log('before api call details to date: ' + this.details_toDate)
        //console.log('target_from_date: ' + this.details_fromDate)

        if (this.user.role == 'driver' && this.company_location && this.company_location != '') {
          results = await get_booking_bids_for_drivers_board_base(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.company_location,this.user.tbn_driver_id,false)

        } else {
          results = await get_booking_bids_for_drivers_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        }
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        const resultsWithRowId = (data.results || []).map((it, idx) => ({
          ...it,
          row_id: idx
        }))
        this.items = resultsWithRowId
        this.items_full = resultsWithRowId
        this.base_options = this.summary.base_options
        if (this.selected_base != '') {
          this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    filter_results() {
      this.items = this.items_full
      if (!this.items)
        return
      if (this.selected_base != '') {
        this.items = this.items.filter(item => item.base_of_operation.indexOf(this.selected_base) != -1)
      }
    },
    onChange(row) {
      if (row && row.item && this.hasBidOrderConflict(row.item)) {
        const conflictedOrder = row.item.bid_order
        this.showAlert(
          `Bid order ${conflictedOrder} is already used for this day. Please choose a different bid order.`,
          'danger',
          5000
        )
        row.item.bid_order = ''
        return
      }
      console.log('Updated:', row)
    },
    async saveDriverUnavailable(ranges) {
      if (!this.user || !this.user.tbn_driver_id) {
        this.$emit('showAlert', 'Driver ID not set. Contact support.', 'danger', 5000)
        return
      }
      try {
        let record = {}
        record.tbn_driver_id = this.user.tbn_driver_id
        record.ranges = ranges
        this.$emit('showAlert', 'waiting for response...', 'info')
        const { message, status_code } = await add_update_driver_unavailable(
          this.tenant_id,
          record
        )
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
      } catch (e) {
        this.$emit(
          'showAlert',
          'error saving driver bid, contact support if needed',
          'danger',
          5000
        )
      }
    },
    async saveDriverBid(bid_record, row) {
      try {
        this.$emit('showAlert', 'waiting for response...', 'info')
        const { message, status_code } = await add_update_driver_bid(
          this.user.tenant,
          bid_record
        )
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
        row.item.booking_status = 'open'
        this.showBidAlert(
            `Success!`,
            'success',
            2000)

        this.$emit('showBidAlert', message || 'Success!', 'success', 1500)
      } catch (e) {
        console.log(e)
        this.$emit(
          'showAlert',
          'error saving driver bid, contact support if needed',
          'danger',
          5000
        )
        this.$emit(
          'showBidAlert',
          'error saving driver bid, contact support if needed',
          'danger',
          5000
        )
      }
    },
    async remove_bid(row) {
      if (row && row.item) {
        if (row.item.booking_status && row.item.booking_status !== 'open') {
          this.showBidAlert(
            `Bid cannot be removed.`,
            'danger',
            5000
          )
          return
        }
        try {
          this.$emit('showAlert', 'waiting for response...', 'info')
          const dispatchDriver = `${row.item.dispatch_id}_${this.user.tbn_driver_id}`
          console.log('remove record dispatch_driver: ' + dispatchDriver)
          const { message, status_code } = await remove_bid_record(
            this.user.tenant,
            dispatchDriver
          )
          this.$emit('showAlert', message || 'Success!', 'success', 1500)
          // clear bid locally so UI updates
          row.item.bid_order = ''
          //row.item.booking_status = 'undefined'
          this.showBidAlert(
            `Success!`,
            'success',
            2000) 

        } catch (e) {
          this.$emit(
            'showAlert',
            'error saving driver bid, contact support if needed',
            'danger',
            5000
          )
        }
      }
    },
    getApprovalText(value) {
      if (!value) return ''
      const opt = (this.approvalOptions || []).find(
        (o) => o && String(o.value) === String(value)
      )
      return opt && opt.text ? opt.text : value
    },
    submit(row) {
      let record = row
      if (row) {
        if (row.item && this.hasBidOrderConflict(row.item)) {
          const conflictedOrder = row.item.bid_order
          this.showAlert(
            `Bid order ${conflictedOrder} is already used for this day. Please choose a different bid order before submitting.`,
            'danger',
            5000
          )
          return
        }
        if (row.item.bid_order) {
          //console.log('row.item.bid_order=' + row.item.bid_order)
        } else {
          //console.log("no row.item.bid_order")
          this.showBidAlert(
            `Please pick a Bid order before submitting.`,
            'danger',
            5000)
          return
        }

        let bid_record = {}

        row.username = this.user.username
        row.employment_status = this.user.employment_status
        row.tbn_driver_id = this.user.tbn_driver_id
        const excludedKeys = ['_showDetails']

        bid_record = Object.fromEntries(
          Object.entries(row.item).filter(([key]) => !excludedKeys.includes(key))
        )
        bid_record.username = this.user.username
        bid_record.employment_status = this.user.employment_status
        bid_record.tbn_driver_id = this.user.tbn_driver_id
        bid_record.driver_name = this.user.full_name
        //console.log('bid_record: ' + JSON.stringify(bid_record))
        this.saveDriverBid(bid_record, row)
      }
      //console.log("submit: " + JSON.stringify(row))
    },
    setup_to_from_bid_dates() {
      const today = new Date();
      const dayOfWeekNumber = today.getDay();

      // Example output: 3 (if today is Wednesday)
      if (dayOfWeekNumber == 4) {
        //console.log("it's thursday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        this.bid_due_warning = "Bids for Sunday and Monday are due "
      } else if (dayOfWeekNumber == 5) {
        //console.log("it's friday")
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(4, 'days').format('MM-DD-YYYY');
        this.bid_due_warning = "Bids for Tuesday and Wednesday are due "
      } else {
        this.details_fromDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        this.details_toDate = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        //this.bid_due_Date = moment(justDate(moment()), 'MM-DD-YYYY').add(3, 'days').format('MM-DD-YYYY');
        if (dayOfWeekNumber == 3){
          this.bid_due_warning = "Bids for Saturday are due "
        } else if (dayOfWeekNumber == 2) {
          this.bid_due_warning = "Bids for Friday are due "
        } else if (dayOfWeekNumber == 1) {
          this.bid_due_warning = "Bids for Thursday are due "
        }
      }
    },
    findCityState(input) {
      //console.log('address: ' + input)
      if (!input) return null

      const text = input.replace(/\s+/g, ' ').trim()
      const STATES = [
        ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
        ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'],
        ['DE', 'Delaware'], ['FL', 'Florida'], ['GA', 'Georgia'],
        ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'],
        ['IA', 'Iowa'], ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'],
        ['ME', 'Maine'], ['MD', 'Maryland'], ['MA', 'Massachusetts'],
        ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
        ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
        ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'],
        ['NM', 'New Mexico'], ['NY', 'New York'], ['NC', 'North Carolina'],
        ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
        ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
        ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'],
        ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'],
        ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
        ['WI', 'Wisconsin'], ['WY', 'Wyoming'], ['DC', 'District of Columbia']
      ]

      // First try to parse addresses like:
      // "..., Washington, DC 20037, USA" -> "Washington, DC"
      const segments = text.split(',').map(s => s.trim()).filter(Boolean)
      if (segments.length >= 2) {
        for (let i = segments.length - 1; i >= 0; i--) {
          const seg = segments[i]
          // Look for a 2-letter state code at the start of a segment (e.g. "DC 20037")
          const abbrMatch = seg.match(/^([A-Za-z]{2})\b/)
          if (!abbrMatch) continue

          const stateAbbr = abbrMatch[1].toUpperCase()
          const stateExists = STATES.some(([abbr]) => abbr === stateAbbr)
          if (!stateExists) continue

          const citySegment = segments[i - 1]
          if (citySegment) {
            return citySegment + ', ' + stateAbbr
          }
        }
      }

      for (const [abbr, full] of STATES) {
        // Match "City, ST" or "City ST"
        const abbrRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${abbr}\\b`,
          'i'
        )

        const fullRegex = new RegExp(
          `([A-Za-z .'-]+?),?\\s+${full}\\b`,
          'i'
        )

        let match = text.match(abbrRegex) || text.match(fullRegex)

        if (match) {
          const city = match[1].trim()
          return city +', ' + abbr
          //return { city, state: abbr }
        }
      }
      return input
    },
    getCityOnly(input) {
      const result = this.findCityState(input)
      if (!result) return ''
      const parts = result.split(',')
      return parts.length > 1 ? parts[0].trim() : result
    },
    getStateOnly(input) {
      const result = this.findCityState(input)
      if (!result) return ''
      const parts = result.split(',')
      return parts.length > 1 ? parts[1].trim() : ''
    },
    getTripDay(item) {
      if (!item || !item.driver_start) {
        return null
      }
      // driver_start is expected in format 'MM-DD-YY HH:mm'
      const m = moment(item.driver_start, 'MM-DD-YY HH:mm', true)
      if (!m.isValid()) {
        console.warn('Unable to parse driver_start for trip day', item.driver_start)
        return null
      }
      return m.format('YYYY-MM-DD')
    },
    getUsedBidOrdersForDay(tripDay, excludeDispatchId) {
      const used = new Set()
      if (!tripDay || !Array.isArray(this.items)) {
        return used
      }
      this.items.forEach((it) => {
        if (!it) return
        const day = this.getTripDay(it)
        if (day !== tripDay) return
        if (excludeDispatchId && it.dispatch_id === excludeDispatchId) return
        if (it.bid_order !== undefined && it.bid_order !== null && String(it.bid_order).trim() !== '') {
          used.add(String(it.bid_order).trim())
        }
      })
      return used
    },
    isBidDisabled(item) {
      if (item.booking_status && item.booking_status !== 'open') {
        return true
      } else if (item.bid_closed_dt && this.isBidCloseDtExpired(item.bid_closed_dt)) {
        return true
      }
      return false
    },
    isBidCloseDtExpired(expiryString) {
      const now = new Date();
      const expiry = new Date(expiryString);
      return now > expiry;
    }
    ,
    isBidOrderDisabled(item, bidOrder) {
      if (!bidOrder) {
        return false
      }
      const tripDay = this.getTripDay(item)
      if (!tripDay) {
        return false
      }
      const used = this.getUsedBidOrdersForDay(tripDay, item && item.dispatch_id)
      const current = item && item.bid_order ? String(item.bid_order).trim() : ''
      if (current === String(bidOrder)) {
        return false
      }
      return used.has(String(bidOrder))
    },
    hasBidOrderConflict(item) {
      if (!item) {
        return false
      }
      const bidOrder = item.bid_order ? String(item.bid_order).trim() : ''
      if (!bidOrder) {
        return false
      }
      return this.isBidOrderDisabled(item, bidOrder)
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${tbn_api_url}tbn/dispatch_board/download`,
          {
            tenant: this.tenant_id,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `dispatch-board-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
    format(date) {
      return date.toISOString().split("T")[0]
    },
    isInRange(date) {
      const d = this.format(date)
      if (!this.ranges) {
        return false;
      }
      return this.ranges.some(r => d >= r.start && d <= r.end)
    },
    handleClick(day) {
      // Block previous month dates
      if (!day.isCurrentMonth && day.date.getMonth() < this.currentMonth &&
        day.date.getFullYear() <= this.currentYear) {
        return
      }
      // Block dates outside allowed range (today → +6 months)
      if (!this.isSelectable(day.date)) return

      // // Auto navigate only if clicking NEXT month date
      // if (!day.isCurrentMonth &&
      //   (day.date.getMonth() > this.currentMonth ||
      //     day.date.getFullYear() > this.currentYear)) {

      //   this.currentMonth = day.date.getMonth()
      //   this.currentYear = day.date.getFullYear()
      // }

      const dateStr = this.format(day.date)

      if (this.isInRange(day.date)) {
        this.removeSingleDay(dateStr)
        this.rangeStart = null
        return
      }

      if (!this.rangeStart) {
        this.rangeStart = dateStr
        return
      }

      const start = this.rangeStart < dateStr ? this.rangeStart : dateStr
      const end = this.rangeStart > dateStr ? this.rangeStart : dateStr

      this.ranges.push({ start, end })
      this.rangeStart = null
    },
    removeSingleDay(date) {
      let updated = []

      this.ranges.forEach(r => {
        if (date < r.start || date > r.end) {
          updated.push(r)
        } else {
          if (date > r.start)
            updated.push({ start: r.start, end: this.prevDate(date) })
          if (date < r.end)
            updated.push({ start: this.nextDate(date), end: r.end })
        }
      })
      this.ranges = updated
    },
    prevDate(date) {
      const d = new Date(date)
      d.setDate(d.getDate() - 1)
      return this.format(d)
    },
    nextDate(date) {
      const d = new Date(date)
      d.setDate(d.getDate() + 1)
      return this.format(d)
    },
    dayClass(day) {
      const dateStr = this.format(day.date)

      // 1️⃣ First, check if the day is in a saved NO range
      if (this.isInRange(day.date)) {
        return "bg-danger text-white"
      }

      // 2️⃣ Block past dates (previous month) — show as muted green or light
      if (!this.isSelectable(day.date)) {
        // Optional: show YES (green) for previous month, or light muted
        return "bg-success text-white"  // use bg-light text-muted if you want grey
      }

      // 3️⃣ Highlight current range start (yellow)
      if (this.rangeStart === dateStr) {
        return "bg-warning"
      }

      // 4️⃣ Default selectable dates = YES (green)
      return "bg-success text-white"
    },
    isSelectable(date) {
      const clean = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      return clean >= this.minDate && clean <= this.maxDate
    },
    saveRanges() {
      //console.log("Saved:", JSON.stringify(this.ranges))
      this.saveDriverUnavailable(this.ranges)
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11
        this.currentYear--
      } else {
        this.currentMonth--
      }
      this.rangeStart = null
      this.fetchRanges()
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0
        this.currentYear++
      } else {
        this.currentMonth++
      }
      this.rangeStart = null
      this.fetchRanges()
    },
    isDayInRange(day) {
      const date = this.formatDate(day)
      if (!this.ranges) {
        return false;
      }
      return this.ranges.some(r => date >= r.start && date <= r.end)
    },
    formatDate(day) {
      const month = String(this.currentMonth + 1).padStart(2, "0")
      const d = String(day).padStart(2, "0")
      return `${this.currentYear}-${month}-${d}`
    },
    async fetchRanges() {
      if (!this.user || !this.user.tbn_driver_id) {
        return
      }
      try {
        var response = null 
        let startDt = moment(this.details_fromDate, 'MM-DD-YYYY').subtract(30, 'days').format('MM-DD-YYYY');
        let endDt = moment(this.details_toDate, 'MM-DD-YYYY').add(60, 'days').format('MM-DD-YYYY');
        response = await get_drivers_unavailable_ranges(this.tenant_id, this.user.tbn_driver_id, startDt, endDt)
        const {value: { data = [] } } = response
        this.ranges = data
      } catch (error) {
        console.error("Failed to load ranges", error)
      }
    },
    canGoPrev() {
      const firstOfMonth = new Date(this.currentYear, this.currentMonth, 1)
      return firstOfMonth > this.minDate
    },
    canGoNext() {
      const firstOfMonth = new Date(this.currentYear, this.currentMonth + 1, 1)
      return firstOfMonth <= this.maxDate
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",").map(f => f.trim())) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field && found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },
    monthYear() {
      return new Date(this.currentYear, this.currentMonth)
        .toLocaleString("default", { month: "long", year: "numeric" })
    },
    monthGrid() {
      const firstDay = new Date(this.currentYear, this.currentMonth, 1)
      const startDay = firstDay.getDay()

      const gridStart = new Date(firstDay)
      gridStart.setDate(firstDay.getDate() - startDay)

      const weeks = []
      let current = new Date(gridStart)

      for (let w = 0; w < 6; w++) {
        const week = []
        for (let d = 0; d < 7; d++) {
          week.push({
            date: new Date(current),
            isCurrentMonth:
              current.getMonth() === this.currentMonth
          })
          current.setDate(current.getDate() + 1)
        }
        weeks.push(week)
      }
      return weeks
    },
    daysInMonth() {
      return new Date(this.currentYear, this.currentMonth + 1, 0).getDate()
    },
    firstDayOfMonth() {
      return new Date(this.currentYear, this.currentMonth, 1).getDay()
    },
    calendarDays() {
      const days = []
      for (let i = 0; i < this.firstDayOfMonth; i++) {
        days.push({ day: null })
      }
      for (let i = 1; i <= this.daysInMonth; i++) {
        days.push({ day: i })
      }
      return days
    },
    noCount() {
      let count = 0
      for (let d = 1; d <= this.daysInMonth; d++) {
        if (this.isDayInRange(d)) count++
      }
      return count
    },
    yesCount() {
      return this.daysInMonth - this.noCount
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 7) {
        alert("please limit tag based date range to 1 week or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'week'))
      }
    },
    selected_base() {
      this.filter_results()
    }
  },
  mounted() {
    this.fetchRanges()
  }
}
</script>

<style scoped>

::v-deep tr.rowgray td { background-color: #ffffff; }
::v-deep tr.rowgray-dark td { background-color: #f2f2f2; }
::v-deep tr.rowgreen td { background-color: #e6ffed; }
::v-deep tr.rowred td { background-color: #ffecec; }
::v-deep tr.rowblue td { background-color: #9ac2ff; }
/* ::v-deep tr.rowblue td { background-color: #e6f0ff; } */
::v-deep tr.rowyellow td { background-color: #c9a227; }

td:first-child {
    font-weight: bold;
  }
.b_bold {
 font-weight: bold;
}
td:nth-child(3) {
    font-weight: bold;
  }
/* td select {
  width: 90%;
  padding: 4px;
} */

@media (max-width: 767.98px) {
  .bid-controls {
    font-size: 16px !important;
  }

  .bid-due-banner {
    position: static !important;
    text-align: center;
    font-size: 14px !important;
    margin-top: 6px;
  }

  ::v-deep .b-table td,
  ::v-deep .b-table th {
    font-size: 12px;
    padding: 4px 6px;
  }

  .detail-info-table,
  .detail-info-table tbody,
  .detail-info-table tr,
  .detail-info-table td {
    display: block;
    width: 100%;
  }

  .detail-info-table tr {
    margin-bottom: 4px;
    border-bottom: 1px solid #eee;
    padding-bottom: 4px;
  }

  .detail-info-table td {
    padding: 1px 0;
    font-size: 13px;
  }

  .row-detail-wrap {
    padding: 6px !important;
    margin: 4px !important;
    font-size: 13px;
  }

  .destination-stacked {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }
}
</style>

